import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export class ERegistryModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { title, text, isOpen, handleClose, onClick, lang, withReject, instance } = this.props;
    return <Modal
      show={isOpen}
      onHide={() => handleClose()}
      container={instance}
      bsSize="sm"
    >
      <Modal.Header>
        {title}
      </Modal.Header>
      { text &&
        <Modal.Body>
          <p style={{fontSize: 13, fontWeight: 'bold'}}>
            {text}
          </p>
        </Modal.Body>
      }
      <Modal.Footer>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <Button
            onClick={onClick}
            className="btn btn-primary"
          >
            OK
          </Button>
          {
            withReject &&
            <Button
              onClick={() => handleClose()}
            >
              NO
            </Button>
          }
        </div>
      </Modal.Footer>
    </Modal>
  }
}
